import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, withRouter } from "react-router-dom";

import URL from "../../../constant/URL";
import http from "../../../http/http";
import useLoading from "../../../hooks/useLoading";
import { useAppBackBtn, useLearningBtn, useLearningHistory, useUserInfo } from "../../../hooks";
import XbtnTitleHeader from "../../common/header/XbtnTitleHeader";
import { getUserAgent } from "../../../utils/utilityEtc";
import useAmplitude from "../../../hooks/useAmplitude";
import _ from "lodash";

const AiPredictionGB = withRouter((props) => {
  const { info } = useUserInfo();
  const { t } = useTranslation();
  const { setBackEventData } = useAppBackBtn();
  const { setAmplitudeLog } = useAmplitude();

  const { setLoading, clearLoading } = useLoading();
  const [, goAiLearning] = useLearningBtn();
  const [resultData, setResultData] = React.useState({});
  const [, setStartFlag] = React.useState(true);
  const location = useLocation();
  const { onLearningExitBtn } = useLearningHistory();

  const moveNext = () => {
    setBackEventData({
      pathname: window.location.pathname,
      state: {selectedLevel: location.state.selectedLevel}
    })
    goAiLearning(resultData);
  };

  const getAiPredictionResult = (aiDiagnosisTestData) => {
    setLoading({ isShowSpinner: true, spinnerType: "1" });
    const { channelCode, learnerId, locale } = info;
    const { state : { selectedLevel }} = location;

    http.request({
      url: `${URL.API.DIAGNOSIS.PROPOSAL}`,
      method: http.METHOD.POST,
      data: {
        chnCd: channelCode,
        lrnMbrId: learnerId,
        grade: "",
        brthmt: selectedLevel,
        sxdnCd: "",
        langCd: locale,
        timeZone: getUserAgent("timeZone"),
        nationCd: getUserAgent("countryCode"),
      },
      success: (res) => {
        if (res?.qstCd) {
          setStartFlag(false);
        }
        clearLoading();
        setResultData(res);
      },
      error: () => {
        clearLoading();
      },
    });
  };

  const goExitPage = useCallback(() => {
    onLearningExitBtn();
  });

  const goBackPage = useCallback(() => {
    props.history.replace({ 
      pathname: URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.DIAGNOSIS_GUIDE3,
      state : {
        selectedLevel : location.state.selectedLevel
      }
    });
  });

  React.useEffect(() => {
    getAiPredictionResult();
    setAmplitudeLog({ eventCategory: "test", eventName: "진단test안내 조회" });
  }, []);

  return (
    <div className="layout-def layout-lc">
      <XbtnTitleHeader title={t("LC_02_05-GB.msg001")} onClose={goExitPage} />
      <div className="container">
        <div className="inner">
          <div className="centermiddleBox">
            <div className="centermiddleBox-row">
              <div className={`dsc_cont4 ${getlanClass()}`}>
                <div className="aic-intro">
                  <div className="aic-intro-item">
                    <h2
                      className="tit"
                      dangerouslySetInnerHTML={{
                        __html: t("LC_02_05-GB.msg002"),
                      }}
                    />
                  </div>
                  <ul className="con_lst">
                    <li>
                      <div className="v-ctr">
                        <p className="sub_tit">{t("LC_02_05-GB.msg003")}</p>
                        <p className="sub_txt">
                          {resultData?.aiPrdcnQstCt
                            ? `10 ${t("LC_02_05-GB.msg004")}`
                            : `0 ${t("LC_02_05-GB.msg004")}`}
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="v-ctr">
                        <p className="sub_tit">{t("LC_02_05-GB.msg005")}</p>
                        <p className="sub_txt">
                          {resultData?.estDiagDur
                            ? `${t("LC_02_05-GB.msg009", {
                                m: resultData.estDiagDur,
                              })}`
                            : `0 ${t("LC_02_05-GB.msg006")}`}
                        </p>
                      </div>
                    </li>
                  </ul>
                  <p
                    className="test_sub_txt"
                    dangerouslySetInnerHTML={{
                      __html: t("LC_02_05-GB.msg007"),
                    }}
                  ></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="footer-inner">
          <div className="d-flex">
            <div className="d-item">
              <button
                className={`btn-small btn-gray btn-left ${getlanClass()}`}
                onClick={goBackPage}
              >
                <span className="m-txt">{t("LC_02_05-GB.msg010")}</span>
              </button>
            </div>
            <div className="d-item btnItem-auto">
              <button
                className={`btn btn-blue ${getlanClass()}`}
                onClick={moveNext}
              >
                {t("LC_02_05-GB.msg008")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default AiPredictionGB;

const getlanClass = () => {
  const { i18n } = useTranslation();
  return _.isEqual(i18n.language === "ko") ? "ko" : "en";
};
